(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
    if (!customElements.get('hero-carousel')) {
        customElements.define('hero-carousel', class extends HTMLElement {
            connectedCallback() {
                this.slides = Array.from(this.querySelector('.seciton-hero-carousel__carousel-wrapper').children);
                if (this.slides.length < 2) return;

                this.index = 0;
                this.delay = Number(this.dataset.autoplay) || 5000;
                this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                this.onVisibility = () => (document.hidden ? this.stop() : this.start());

                // Autoplay waits for an input that also ends LCP measurement (tap, click, key, wheel). Until then each newly
                // shown slide is a fresh paint that can be counted as the page's LCP, and lab tests (PageSpeed) never give
                // input. Mouse movement does not end LCP, so it is not a trigger. 'scroll' is left out because Lighthouse
                // scrolls the page itself. 30s fallback for visitors who never interact.
                this.autoplayAllowed = false;
                this.interactionEvents = ['pointerdown', 'keydown', 'touchstart', 'wheel'];
                this.onFirstInteraction = () => this.allowAutoplay();
                this.interactionEvents.forEach((name) => window.addEventListener(name, this.onFirstInteraction, { once: true, passive: true }));
                this.autoplayFallbackTimer = setTimeout(() => this.allowAutoplay(), 30000);

                // Start after the page has loaded so the other slides never delay the first one.
                // Fallback: slow third-party scripts can hold back the load event, so start after 8s regardless.
                if (document.readyState === 'complete') this.init();
                else {
                    window.addEventListener('load', () => this.init(), { once: true });
                    this.fallbackTimer = setTimeout(() => this.init(), 8000);
                }
            }

            disconnectedCallback() {
                this.stop();
                clearTimeout(this.autoplayFallbackTimer);
                this.interactionEvents?.forEach((name) => window.removeEventListener(name, this.onFirstInteraction));
                document.removeEventListener('visibilitychange', this.onVisibility);
            }

            allowAutoplay() {
                if (this.autoplayAllowed) return;
                this.autoplayAllowed = true;
                clearTimeout(this.autoplayFallbackTimer);
                this.interactionEvents.forEach((name) => window.removeEventListener(name, this.onFirstInteraction));
                this.start();
            }

            init() {
                clearTimeout(this.fallbackTimer);
                if (this.hasAttribute('data-ready') || !this.isConnected) return;
                this.slides[0].classList.add('is-active');
                this.setAttribute('data-ready', '');
                this.buildDots();
                this.bindEvents();
                this.start();
            }

            buildDots() {
                const wrap = this.querySelector('.seciton-hero-carousel__dots');
                this.dots = this.slides.map((_, i) => {
                    const dot = document.createElement('button');
                    dot.type = 'button';
                    dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
                    dot.setAttribute('aria-current', i === 0 ? 'true' : 'false');
                    dot.addEventListener('click', () => {
                        this.goTo(i);
                        this.restart();
                    });
                    wrap.appendChild(dot);
                    return dot;
                });
            }

            bindEvents() {
                this.addEventListener('mouseenter', () => this.stop());
                this.addEventListener('mouseleave', () => this.start());
                document.addEventListener('visibilitychange', this.onVisibility);

                let startX = null;
                this.addEventListener('touchstart', (e) => {
                    startX = e.touches[0].clientX;
                }, { passive: true });
                this.addEventListener('touchend', (e) => {
                    if (startX === null) return;
                    const dx = e.changedTouches[0].clientX - startX;
                    startX = null;
                    if (Math.abs(dx) > 40) {
                        this.goTo(this.index + (dx < 0 ? 1 : -1));
                        this.restart();
                    }
                }, { passive: true });

                // Theme editor: show the slide whose block is selected
                this.addEventListener('shopify:block:select', (e) => {
                    const i = this.slides.findIndex((slide) => slide.contains(e.target));
                    if (i > -1) {
                        this.stop();
                        this.goTo(i);
                    }
                });
            }

            goTo(i) {
                const next = (i + this.slides.length) % this.slides.length;
                if (next === this.index) return;
                this.slides[this.index].classList.remove('is-active');
                this.slides[next].classList.add('is-active');
                this.dots[this.index].setAttribute('aria-current', 'false');
                this.dots[next].setAttribute('aria-current', 'true');
                this.index = next;
            }

            start() {
                if (this.reducedMotion || this.timer || !this.autoplayAllowed || !this.hasAttribute('data-ready')) return;
                this.timer = setInterval(() => this.goTo(this.index + 1), this.delay);
            }

            stop() {
                clearInterval(this.timer);
                this.timer = null;
            }

            restart() {
                this.stop();
                this.start();
            }
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["protein-source"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    // Illustrated bowl, used when no bowl image is chosen or it fails to load.
    function fallbackBowl() {
      var seed = 11;
      function rand() { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; }
      var tones = ['#b5333f', '#cc4a57', '#de6f78', '#9a2734', '#f3b2b1', '#c13d4b'];
      var mince = '';
      for (var k = 0; k < 190; k++) {
        var a = rand() * Math.PI * 2, d = Math.sqrt(rand());
        var x = 200 + Math.cos(a) * d * 120, y = 152 + Math.sin(a) * d * 36;
        mince += '<circle cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="' + (1.8 + rand() * 3.4).toFixed(1) + '" fill="' + tones[k % tones.length] + '"/>';
      }
      var cubes = [[150, 138, 18], [236, 128, -14], [272, 158, 32], [182, 168, -8], [118, 160, 24]].map(function (c) {
        return '<rect x="' + (c[0] - 5) + '" y="' + (c[1] - 5) + '" width="10" height="10" rx="2" fill="#f2994a" transform="rotate(' + c[2] + ' ' + c[0] + ' ' + c[1] + ')"/>';
      }).join('');
      var greens = [[206, 140, 20], [258, 146, -30], [140, 148, 40], [226, 170, 10]].map(function (g) {
        return '<ellipse cx="' + g[0] + '" cy="' + g[1] + '" rx="7" ry="3" fill="#78965a" transform="rotate(' + g[2] + ' ' + g[0] + ' ' + g[1] + ')"/>';
      }).join('');

      return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400">' +
        '<defs>' +
          '<linearGradient id="s" x1="0" x2="1"><stop offset="0" stop-color="#e6d0c0"/><stop offset=".42" stop-color="#fffaf6"/><stop offset="1" stop-color="#d8bfad"/></linearGradient>' +
          '<radialGradient id="m" cx=".5" cy=".35" r=".7"><stop offset="0" stop-color="#d95c68"/><stop offset="1" stop-color="#a02e3b"/></radialGradient>' +
          '<clipPath id="b"><path d="M50 172C54 252 112 312 200 312S346 252 350 172Z"/></clipPath>' +
        '</defs>' +
        '<ellipse cx="200" cy="308" rx="94" ry="10" fill="#d9c2b1"/>' +
        '<path d="M50 172C54 252 112 312 200 312S346 252 350 172Z" fill="url(#s)"/>' +
        '<path d="M40 232C100 268 300 268 360 232" fill="none" stroke="#ff4a04" stroke-width="7" clip-path="url(#b)"/>' +
        '<ellipse cx="200" cy="170" rx="150" ry="52" fill="#fffaf5" stroke="#e5d0c1" stroke-width="2"/>' +
        '<ellipse cx="200" cy="172" rx="134" ry="44" fill="#8c2531"/>' +
        '<path d="M66 174C80 128 150 108 204 110S322 130 334 174C334 202 66 202 66 174Z" fill="url(#m)"/>' +
        mince + cubes + greens +
        '<path d="M50 170A150 52 0 0 0 350 170L334 172A134 44 0 0 1 66 172Z" fill="#fffaf5"/>' +
        '<path d="M50 170A150 52 0 0 0 350 170" fill="none" stroke="#e5d0c1" stroke-width="2"/>' +
      '</svg>';
    }

    function init(root) {
      if (root.proteinIndex) return;

      var panel = root.querySelector('.protein-index-panel');
      var bowl = root.querySelector('.protein-index-bowl');
      var img = root.querySelector('.protein-index-bowl-img');
      var orbitersEl = root.querySelector('.protein-index-orbiters');
      var statusText = root.querySelector('.protein-index-status-text');
      var nameEl = root.querySelector('.protein-index-feature-name');
      var originEl = root.querySelector('.protein-index-feature-origin');
      var cta = root.querySelector('.protein-index-cta');
      var ctaLabel = root.querySelector('.protein-index-cta-label');
      var rows = Array.prototype.slice.call(root.querySelectorAll('.protein-index-row'));
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var current = null;
      var swapTimer = 0;
      var leaveTimer = 0;

      // ---- Bowl image fallback ----
      function useFallback() {
        if (img.getAttribute('data-protein-index-fallback')) return;
        img.setAttribute('data-protein-index-fallback', '1');
        img.removeAttribute('srcset');
        img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(fallbackBowl());
      }
      if (img) {
        img.addEventListener('error', useFallback);
        if (!img.getAttribute('src') || (img.complete && img.naturalWidth === 0)) useFallback();
      }

      // ---- Orbiting icons: one per row, spaced evenly around the ring ----
      var orbiters = rows.map(function (row, i) {
        var orbiter = document.createElement('span');
        orbiter.className = 'protein-index-orbiter';
        orbiter.style.setProperty('--protein-index-a', (i * 360 / rows.length) + 'deg');
        var badge = document.createElement('span');
        badge.className = 'protein-index-orbiter-badge';
        var face = document.createElement('span');
        face.className = 'protein-index-orbiter-face';
        var icon = row.querySelector('.protein-index-icon');
        if (icon) face.appendChild(icon.cloneNode(true));
        badge.appendChild(face);
        orbiter.appendChild(badge);
        orbitersEl.appendChild(orbiter);
        return orbiter;
      });

      // ---- Rotation: eases between a cruising and a slow speed ----
      var SPEED = 360 / 60;      // degrees per second: one turn a minute
      var SLOW_SPEED = SPEED * 0.15;
      var spin = 0;
      var speed = SPEED;
      var targetSpeed = SPEED;
      var visible = true;
      var lastTime = 0;
      var frame = 0;

      function tick(now) {
        frame = 0;
        var dt = lastTime ? Math.min(now - lastTime, 64) / 1000 : 0;
        lastTime = now;
        speed += (targetSpeed - speed) * Math.min(1, dt * 3);
        spin = (spin + speed * dt) % 360;
        bowl.style.setProperty('--protein-index-spin', spin.toFixed(2) + 'deg');
        if (visible) frame = requestAnimationFrame(tick);
      }

      function run() {
        if (reduceMotion || frame || !visible) return;
        lastTime = 0;
        frame = requestAnimationFrame(tick);
      }

      // ---- Feature panel ----
      var summary = {
        state: panel.getAttribute('data-state'),
        status: statusText.textContent,
        name: nameEl.textContent,
        origin: originEl.textContent,
        cta: ctaLabel.textContent,
        href: cta.getAttribute('href') || ''
      };

      function render(data) {
        function update() {
          panel.setAttribute('data-state', data.state);
          statusText.textContent = data.status;
          nameEl.textContent = data.name;
          originEl.textContent = data.origin;
          ctaLabel.textContent = data.cta;
          cta.setAttribute('href', data.href);
          cta.hidden = !data.href;
          panel.classList.remove('is-swapping');
        }
        clearTimeout(swapTimer);
        if (reduceMotion) {
          update();
        } else {
          panel.classList.add('is-swapping');
          swapTimer = setTimeout(update, 180);
        }
      }

      function dataFor(row) {
        var confirmed = row.getAttribute('data-status') === 'confirmed';
        var name = row.getAttribute('data-name');
        var origin = row.getAttribute('data-origin');
        var link = row.getAttribute('data-link');
        return {
          state: confirmed ? 'confirmed' : 'pending',
          status: panel.getAttribute(confirmed ? 'data-confirmed-label' : 'data-pending-label'),
          name: name,
          origin: confirmed && origin ? origin : panel.getAttribute('data-pending-text'),
          // Without its own link, the button keeps the default "Shop all" label and link.
          cta: link ? (panel.getAttribute('data-cta-prefix') + ' ' + name).trim() : summary.cta,
          href: link || summary.href
        };
      }

      function activate(row) {
        clearTimeout(leaveTimer);
        if (row === current) return;
        if (current) {
          current.classList.remove('is-current');
          orbiters[rows.indexOf(current)].classList.remove('is-active');
        }
        current = row;
        row.classList.add('is-current');
        orbiters[rows.indexOf(row)].classList.add('is-active');
        bowl.classList.add('has-active');
        targetSpeed = SLOW_SPEED;
        render(dataFor(row));
      }

      function deactivate() {
        // A short delay stops the panel flickering when moving between rows.
        clearTimeout(leaveTimer);
        leaveTimer = setTimeout(function () {
          if (!current) return;
          current.classList.remove('is-current');
          orbiters[rows.indexOf(current)].classList.remove('is-active');
          current = null;
          bowl.classList.remove('has-active');
          targetSpeed = SPEED;
          render(summary);
        }, 140);
      }

      rows.forEach(function (row) {
        row.addEventListener('mouseenter', function () { activate(row); });
        row.addEventListener('mouseleave', deactivate);
      });

      // Stop the rotation loop while the section is off-screen.
      var observer = null;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          if (visible) run();
        });
        observer.observe(root);
      }

      run();

      root.proteinIndex = {
        activateIndex: function (i) { if (rows[i]) activate(rows[i]); },
        rowIndexFor: function (el) {
          var row = el && el.querySelector('.protein-index-row');
          return rows.indexOf(row);
        },
        deactivate: deactivate,
        destroy: function () {
          visible = false;
          if (frame) cancelAnimationFrame(frame);
          if (observer) observer.disconnect();
          clearTimeout(swapTimer);
          clearTimeout(leaveTimer);
        }
      };
    }

    function initAll(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-protein-index]'), init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();

    // Theme editor support
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target.querySelector('[data-protein-index]');
      if (root && root.proteinIndex) root.proteinIndex.destroy();
    });

    document.addEventListener('shopify:block:select', function (event) {
      var root = event.target.closest('[data-protein-index]');
      if (!root || !root.proteinIndex) return;
      root.proteinIndex.activateIndex(root.proteinIndex.rowIndexFor(event.target));
    });

    document.addEventListener('shopify:block:deselect', function (event) {
      var root = event.target.closest('[data-protein-index]');
      if (root && root.proteinIndex) root.proteinIndex.deactivate();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
